import axios from 'axios'
import { baseRequestHandler } from 'api/http-client/request-handler'

const formatLocationObject = (location = {}) => {
  location.lng = location.lon
  return location
}

export default {
  search(location, lang) {
    const url = `https://nominatim.openstreetmap.org/search?q=${location}&format=jsonv2&addressdetails=1&accept-language=${lang}&dedupe=1&limit=10`
    return axios.get(url)
      .then(({ data }) => (data ? data.map(formatLocationObject) : []))
  },
  add(data) {
    const url = 'location'
    return baseRequestHandler.post(url, data)
      .then(({ result }) => result)
  },
}
